  // Export
  const _modal = require("./_modal");
  module.exports =
  {
    
    checkAvailability: {
        _init: function() {
          let selectedModal = ""
          if(document.querySelector("#AvailabilityUnavailable.bubble-modal-body")){
             selectedModal = "AvailabilityUnavailable"
          }
          else if(document.querySelector("#AvailabilityAvailable.bubble-modal-body")){
             selectedModal = "AvailabilityAvailable"
          }
          else{
             selectedModal = "CheckAvailability"
          }
          _modal.setupModals(
                selectedModal,
                {
                  'CheckAvailability': {
                    display: "flex",
                    colour: "#EBF8FD",
                    auto_height: true,
                    width: "470px",
                    center: true,
                  },
                  'AvailabilityUnavailable': {
                    display: "flex",
                    colour: "#2B8CC6",
                    auto_height: true,
                    width: "380px",
                    center: true,
                  },
                  'AvailabilityAvailable': {
                    display: "flex",
                    colour: "#2B8CC6",
                    px_height: "341px",
                    auto_height: false,
                    width: "380px",
                    center: true,
                  },
                },
                () => {}
              );
        },
    },


  }